import { useEffect, useMemo, useState } from 'react';
import { ShopListItem } from '~/components/ui/ShopListItem';
import { IVehicleTuningShopItem, rage } from '~/rage';
import { VehicleTuningCategory, WalletType } from '~/shared';

const ListTabItem = ({
	item,
	index,
	activeCategory,
	activeListIndex,
	handleSelect,
	variantIndex,
}: {
	item: IVehicleTuningShopItem;
	index: number;
	activeCategory: VehicleTuningCategory;
	activeListIndex: number | null;
	handleSelect: (index: number) => void;
	variantIndex?: number;
}) => {
	const seenTrackerKey = `${activeCategory}.${item.id}`;
	const [isUnseen, setIsUnseen] = useState(
		rage.vehicleTuningShop.isUnseen(seenTrackerKey),
	);

	useEffect(() => {
		if (index === activeListIndex) {
			const seenTrackerKey = `${activeCategory}.${item.id}`;
			rage.vehicleTuningShop.markSeen(seenTrackerKey);
			setIsUnseen(false);
		}
	}, [index, activeListIndex, activeCategory, item.id]);

	const title = useMemo(() => {
		if (variantIndex === undefined || !item.variants?.length) {
			return item.name;
		}
		const v = item.variants[variantIndex];
		return v?.name ? `${item.name} — ${v.name}` : item.name;
	}, [item, variantIndex]);

	const price = useMemo(() => {
		if (variantIndex === undefined || !item.variants?.length) {
			return item.price;
		}
		const v = item.variants[variantIndex];
		return v?.price ?? item.price;
	}, [item, variantIndex]);

	const isInstalled = useMemo(() => {
		if (variantIndex === undefined || !item.variants?.length) {
			return item.isInstalled;
		}
		const v = item.variants[variantIndex];
		return v?.isInstalled ?? item.isInstalled;
	}, [item, variantIndex]);

	return (
		<ShopListItem
			title={title}
			price={price}
			walletType={WalletType.Cash}
			id={`tuning-${item.id}`}
			handleClick={() => handleSelect(index)}
			active={index === activeListIndex}
			isNew={isUnseen}
			installed={isInstalled}
			allowSelectInstalled
			key={index}
			variantIndex={item.variants?.length ? (variantIndex ?? 0) + 1 : undefined}
			maxVariantIndex={item.variants?.length}
		/>
	);
};

export { ListTabItem };
